import { useQuery } from "@tanstack/react-query";
import type { UseQueryOptions } from "@tanstack/react-query/src/types";
import { useDispatch } from "react-redux";
import { receiveEntities } from "actions/context";
import type { IBrandGroup } from "helpers/transforms/entities";
import { type IEntitiesQuery, getEntities } from "interfaces/app";

export function useBrandGroupsWithQueries(
  query: IEntitiesQuery = {},
  options?: Omit<
    UseQueryOptions<
      IBrandGroup[],
      unknown,
      IBrandGroup[],
      ["brandGroups", IEntitiesQuery]
    >,
    "queryFn"
  >
) {
  const dispatch = useDispatch();
  return useQuery(["brandGroups", query], {
    ...options,
    queryFn: async () => {
      const entities = await getEntities(query);
      dispatch(receiveEntities(entities));
      return entities;
    },
  });
}
